import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import AwardFormLayer from "../components/AwardFormLayer";

const AwardFormPage = () => {
  return (
    <>
      <MasterLayout>
        <AwardFormLayer />
      </MasterLayout>
    </>
  );
};

export default AwardFormPage;
